export default [{
    code: 'btc',
    name: "Bitcoin",
    mul: 100000000
}, {
    code: 'bch',
    name: "BitcoinCash",
    mul: 100000000
}, {
    code: 'xec',
    name: "eCash",
    mul: 100
}, {
    code: 'dgb',
    name: "Digibyte",
    mul: 100000000
}, {
    code: 'rvn',
    name: "Ravencoin",
    mul: 100000000
}]
